export enum NgxExcelColumnType {
  Text = 'text',
  TextNumber = 'textNumber',
  MultilineText = 'multilineText',
  Number = 'number',
  Currency = 'currency',
  DateTime = 'datetime',
  Date = 'date',
  Time = 'time',
  DateTimeRange = 'datetimeRange',
  DateRange = 'dateRange',
  Bool = 'bool',
  Array = 'array',
  Url = 'url',
  SelectOption = 'selectOption',
  MultiSelectOption = 'multiSelectOption',
  TagsSelectOption = 'tagsSelectOption',
  PrimaryKey = 'primaryKey',
  ForeignKey = 'foreignKey',
  MultiForeignKey = 'multiForeignKey',
  UploadFile = 'uploadFile',
  MultiUploadFile = 'multiUploadFile'
}

export enum NgxExcelComponentState {
  Initial = 'initial',
  Normal = 'normal',
  Complete = 'complete',
  Loading = 'loading',
  Warning = 'warning'
}

export enum NgxExcelCellMode {
  ReadMode = 'readMode',
  EditMode = 'editMode',
  Loading = 'loading'
}
